import { afterHoursNav } from './nav';
import { headerClearance } from './header-clearance';

(function () {
    afterHoursNav();
    headerClearance();
})();
